import React, { FC, useMemo } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { Breadcrumb, BreadCrumbItem } from 'src/Components/Breadcrumb'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'

const NAVIGATE_BACK_INDEX = -1

export const CreateCampaignBreadcrumbsNoAuthAds: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isPlaylist = pathname.includes('/playlist')

  const breadcrumbItems: BreadCrumbItem[] = useMemo(() => {
    const items: BreadCrumbItem[] = [
      {
        title: 'Campaign type',
        path: PublicRoutesEnum.CreateCampaign,
      },
      {
        title: 'Strategy type',
        path: `${PublicRoutesEnum.CreateAdsCampaign}`,
      },
      {
        title: isPlaylist ? 'Playlist search' : 'Track search',
        path: isPlaylist
          ? `${PublicRoutesEnum.CreateAdsCampaign}/playlist`
          : `${PublicRoutesEnum.CreateAdsCampaign}/track`,
      },

      {
        title: 'Contact details',
        path: '',
      },
    ]

    return items
  }, [isPlaylist])

  const onBreadcrumbButtonClick = (): void => {
    navigate(NAVIGATE_BACK_INDEX)
  }

  const filteredBreadcrumbItems: BreadCrumbItem[] = breadcrumbItems.reduce<{
    items: BreadCrumbItem[]
    found: boolean
  }>(
    (acc, item) => {
      if (acc.found) {
        return acc
      }
      acc.items.push(item)
      const [itemPathname] = item.path.split('?')
      if (itemPathname === pathname) {
        acc.found = true
      }
      return acc
    },
    { items: [], found: false },
  ).items

  return (
    <Breadcrumb
      items={filteredBreadcrumbItems}
      onButtonClick={onBreadcrumbButtonClick}
    />
  )
}
